import { render } from "./Content.vue?vue&type=template&id=7eab81f9"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7eab81f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7eab81f9', __exports__)) {
    console.log('reload')
    api.reload('7eab81f9', __exports__)
  }
  
  module.hot.accept("./Content.vue?vue&type=template&id=7eab81f9", () => {
    console.log('re-render')
    api.rerender('7eab81f9', render)
  })

}


export default __exports__